import GetGifsById from '@/docs-partials/api/endpoints/get-gifs-by-id.mdx';
import * as React from 'react';
export default {
  GetGifsById,
  React
};